"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.recalculateOrderFormValues = exports.isOrderEntryFormChanged = void 0;
var _reduxForm = require("redux-form");
var _includes = _interopRequireDefault(require("lodash/includes"));
var _apex = _interopRequireDefault(require("../apex"));
var _orderHelper = require("./orderHelper");
var _placeOrderHelper = require("./placeOrderHelper");
var _orderEntryFormConstants = require("../constants/sendOrder/orderEntryFormConstants");
var _orderEntrySelector = require("../redux/selectors/orderEntrySelector");
var _instrumentPositionSelectors = require("../redux/selectors/instrumentPositionSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/**
 * Recalculate `order fee` and `total amount` for default order entry form
 */
var recalculateOrderFormValues = exports.recalculateOrderFormValues = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(store, options) {
    var state, apexCore, level1, products, form, formName, initOrders, orders, selectedInstrument, totalAmount, payload, fee, _products$find, decimalPlaces, orderFee;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          state = store.getState();
          apexCore = state.apexCore;
          level1 = apexCore.level1, products = apexCore.product.products;
          form = options.form, formName = options.formName, initOrders = options.orders;
          orders = _toConsumableArray(initOrders);
          selectedInstrument = level1[(0, _instrumentPositionSelectors.selectedInstrumentSelector)(state).InstrumentId] || {};
          form.side === _orderEntryFormConstants.buyValue ? orders.sort(function (a, b) {
            if (a.Price > b.Price) return 1;
            if (a.Price < b.Price) return -1;
            return 0;
          }) : orders.sort(function (a, b) {
            if (a.Price < b.Price) return 1;
            if (a.Price > b.Price) return -1;
            return 0;
          });
          totalAmount = (0, _orderEntrySelector.orderTotalSelector)(state, {
            form: form
          });
          if (totalAmount.toString() === 'NaN') totalAmount = 0;
          payload = getBaseOptionsForGetOrderFeeRequest(store, form, totalAmount, selectedInstrument);
          _context.n = 1;
          return _getOrderFeeForDefaultForm(payload, form, store);
        case 1:
          fee = _context.v;
          if (fee) {
            decimalPlaces = (_products$find = products.find(function (product) {
              return product.ProductId === fee.ProductId;
            })) === null || _products$find === void 0 ? void 0 : _products$find.DecimalPlaces;
            orderFee = Number(fee.OrderFee.toFixed(decimalPlaces));
            fee.OrderFee = orderFee;
          }
          store.dispatch((0, _reduxForm.change)(formName, 'fee', fee));
        case 2:
          return _context.a(2);
      }
    }, _callee);
  }));
  return function recalculateOrderFormValues(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var isOrderEntryFormChanged = exports.isOrderEntryFormChanged = function isOrderEntryFormChanged(_ref2) {
  var type = _ref2.type,
    meta = _ref2.meta;
  return type === _reduxForm.actionTypes.CHANGE && !meta.field.includes('fee') && !meta.field.includes('anchoredField') && !meta.field.includes('percent') && (0, _includes["default"])(['orderEntry', 'advancedOrderEntry', 'reportBlockTrade'], meta.form);
};
var _getOrderFeeForDefaultForm = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(payload) {
    var cacheKey;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          cacheKey = JSON.stringify(payload);
          if (!_getOrderFeeForDefaultForm._cache) {
            _getOrderFeeForDefaultForm._cache = {};
          }
          if (!(_getOrderFeeForDefaultForm._cache.payload !== cacheKey)) {
            _context2.n = 2;
            break;
          }
          _getOrderFeeForDefaultForm._cache.payload = cacheKey;
          _context2.n = 1;
          return _apex["default"].connection.GetOrderFee(payload);
        case 1:
          _getOrderFeeForDefaultForm._cache.response = _context2.v;
        case 2:
          return _context2.a(2, _getOrderFeeForDefaultForm._cache.response);
      }
    }, _callee2);
  }));
  return function getOrderFeeForDefaultForm(_x3) {
    return _ref3.apply(this, arguments);
  };
}();
var getBaseOptionsForGetOrderFeeRequest = function getBaseOptionsForGetOrderFeeRequest(store, orderEntryForm, totalAmount, selectedInstrument) {
  var _store$getState = store.getState(),
    user = _store$getState.user;
  var price = getPriceForGetOrderFeeRequest(orderEntryForm, selectedInstrument);
  var side = parseInt(orderEntryForm.side, 10);
  var quantity = getQuantityForGetOrderFeeRequest(orderEntryForm, totalAmount);
  var amount = getAmountForGetOrderFeeRequest(orderEntryForm, totalAmount, price);
  if (_typeof(amount) === 'object') {
    amount = amount.toNumber();
  }
  if (orderEntryForm.orderType === _orderEntryFormConstants.orderTypes.market.displayName && orderEntryForm.anchoredField === 'value') {
    if (orderEntryForm.side === '0') {
      quantity = amount;
    }
  }
  return {
    OMSId: user.userInfo.OMSId,
    AccountId: user.selectedAccountId,
    InstrumentId: selectedInstrument.InstrumentId,
    Amount: amount,
    Quantity: quantity,
    Side: side,
    Price: price,
    OrderType: parseInt((0, _placeOrderHelper.getOrderTypeByName)(orderEntryForm.orderType), 10),
    MakerTaker: (0, _orderHelper.isMakerOrTaker)(side, price, selectedInstrument.BestBid, selectedInstrument.BestOffer, orderEntryForm.orderType)
  };
};
var getPriceForGetOrderFeeRequest = function getPriceForGetOrderFeeRequest(formValues, selectedInstrument) {
  if (formValues.orderType === _orderEntryFormConstants.orderTypes.market.displayName) {
    if (formValues.side === _orderEntryFormConstants.buyValue) {
      return selectedInstrument.BestOffer;
    }
    return selectedInstrument.BestBid;
  }
  if (formValues.orderType === _orderEntryFormConstants.orderTypes.stopMarket.displayName) {
    return formValues.stopPrice;
  }
  if (formValues.orderType === _orderEntryFormConstants.orderTypes.reportBlockTrade.displayName) {
    var quantity = formValues.quantity,
      price = formValues.price;
    if (!quantity || !price) return undefined;
    if (formValues.side === _orderEntryFormConstants.buyValue) {
      if (formValues.quantity <= 0) {
        formValues.quantity = 1;
      }
      if (formValues.useNewForm) {
        // "useNewForm" indicates that we are treating the BlockTrade form
        // like a standard order entry, where user inputs the intended price.
        return formValues.price;
      }
      return formValues.price / formValues.quantity;
    } else {
      if (formValues.price <= 0) {
        formValues.price = 1;
      }
      if (formValues.useNewForm) {
        // "useNewForm" indicates that we are treating the BlockTrade form
        // like a standard order entry, where user inputs the intended price.
        return formValues.quantity;
      }
      return formValues.quantity / formValues.price;
    }
  }
  return formValues.limitPrice ? formValues.limitPrice : undefined;
};
var getQuantityForGetOrderFeeRequest = function getQuantityForGetOrderFeeRequest(formValues, totalAmount) {
  if (formValues.orderType === _orderEntryFormConstants.orderTypes.reportBlockTrade.displayName) {
    var price = formValues.price;
    if (!price) {
      formValues.quantity = 0;
      return undefined;
    }
    if (formValues.side === _orderEntryFormConstants.sellValue) {
      return formValues.price;
    }
  }

  // over-ride for market-by-value.
  if (formValues.orderType === _orderEntryFormConstants.orderTypes.market.displayName && formValues.side === '0' && formValues.anchoredField === 'value') {
    if (_typeof(formValues.value) === 'object') {
      return formValues.value.toNumber() / totalAmount;
    }
    return formValues.value / totalAmount;
  }
  if (_typeof(formValues.quantity) === 'object') {
    return formValues.quantity.toNumber();
  }
  return formValues.quantity;
};
var getAmountForGetOrderFeeRequest = function getAmountForGetOrderFeeRequest(formValues, totalAmount, price) {
  if (formValues.orderType === _orderEntryFormConstants.orderTypes.reportBlockTrade.displayName) {
    return 0;
  }
  if (formValues.anchoredField === 'value') {
    if (formValues.side === '0') {
      return totalAmount / price;
    }
    return totalAmount;
  }
  return formValues.side === '1' ? totalAmount : formValues.quantity;
};